import styled from 'styled-components';

export const ModalTitle = styled.h2`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: var(--color-title);
  margin: 0;
  text-align: center;
`;
